/**
 * Safe typed array pointer for WASM shared memory
 */
export class WasmSharedTypedArray {
    array;
    /**
     * Create a safe typed array pointer for WASM shared memory
     *
     * @param typedArrayConstructor typed array constructor
     * @param memory WebAssembly memory
     * @param byteOffset byte offset of the typed array
     * @param length length of the typed array
     */
    constructor(typedArrayConstructor, memory, byteOffset, length) {
        this.array = new typedArrayConstructor(memory.buffer, byteOffset, length);
    }
}
